import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import BorderColorIcon from '@mui/icons-material/BorderColor'
import DeleteIcon from '@mui/icons-material/Delete'
import LockIcon from '@mui/icons-material/Lock'
import LockOpenIcon from '@mui/icons-material/LockOpen'
import SearchIcon from '@mui/icons-material/Search'
import { Box, Button, Divider, Typography } from '@mui/material'
import { CustomModalContext } from 'common/contexts/CustomModalContext'
import { ModalTypes } from 'common/hooks/useCustomModal'
import { enqueueSnackbar, SnackbarProvider } from 'notistack'
import { useContext, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import AddExpenseButton from '../components/AddExpenseButton'
import { HojasGastoLin } from '../components/HojasGastoLin'
import HeaderCard from '../components/HojasGastosCard'
import useFetchHojaGasto from '../hooks/useFetchHojaGasto'
import {
  closeHojaGasto,
  deleteHojaGasto,
  getDetalladaHoja,
  getFirmasHoja,
  openHojaGasto,
} from '../lib/HojasGastoController'

export const HojasGastoLinPage = ({ id_h, encr, disableAll = false }) => {
  const { id_hoja } = useParams()
  const id = id_hoja ? id_hoja : id_h
  const [iterator, setIterator] = useState(1)
  const [buttons, setButtons] = useState([])
  const [forcedAmount, setForcedAmount] = useState(null)

  const { response, error, loading } = useFetchHojaGasto({
    id_hoja: id,
    encr,
    iterator,
  })

  const navigate = useNavigate()

  const { handleModal } = useContext(CustomModalContext)

  const handleClick = async () => {
    try {
      handleModal({ type: ModalTypes.Loading })
      const res = await closeHojaGasto({ id: response.id })
      handleModal({ enabled: false })
      if (res) setIterator(Math.random())
    } catch (e) {
      handleModal({ enabled: false })
    }
  }
  const handleDeleteClick = async () => {
    try {
      handleModal({ type: ModalTypes.Loading })
      const res = await deleteHojaGasto({ id: response.id })
      handleModal({ enabled: false })
      if (res) navigate('/hojasgasto/')
    } catch (e) {
      enqueueSnackbar(
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          <Typography>Lo sentimos.</Typography>
          <Typography>No se ha podido borrar la hoja de gastos en este momento.</Typography>
        </Box>,
      )
      handleModal({ enabled: false })
    }
  }

  const handleDetalladaClick = async ({ id }) => {
    try {
      handleModal({ type: ModalTypes.Loading })
      await getDetalladaHoja({ id })
      handleModal({ enabled: false })
    } catch (e) {
      handleModal({ enabled: false })
      enqueueSnackbar('No se ha podido obtener la vista detallada')
    }
  }
  const handleFirmasClick = async ({ id }) => {
    try {
      handleModal({ type: ModalTypes.Loading })
      await getFirmasHoja({ id })
      handleModal({ enabled: false })
    } catch (e) {
      handleModal({ enabled: false })
      enqueueSnackbar('No se ha podido obtener la vista de firmas')
    }
  }
  const handleChangeState = () => {
    setIterator(iterator + 1)
  }

  const handleOpenClick = async ({ id }) => {
    try {
      handleModal({ type: ModalTypes.Loading })
      const res = await openHojaGasto({ id })
      handleModal({ enabled: false })
      if (!res) return
      setIterator(iterator + 1)
    } catch (error) {
      // Error handled
    }
  }

  const deleteButtonOnclick = () => {
    handleModal({
      type: ModalTypes.Confirm,
      closable: true,
      enabled: true,
      content: (
        <Box>
          <Typography variant="h5">Atención</Typography>
          <Divider sx={{ mb: 2 }} />
          <Typography sx={{ mb: 2 }}>
            Está seguro de que desea eliminar esta hoja de gasto?
          </Typography>
        </Box>
      ),
      confirmDialogButtons: (
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            flexWrap: 'wrap',
            justifyContent: 'space-between',
          }}
        >
          <Button
            variant="contained"
            onClick={() => {
              handleModal({ enabled: false })
              handleDeleteClick()
            }}
            color="error"
            startIcon={<DeleteIcon />}
          >
            Borrar
          </Button>
          <Button variant="contained" onClick={() => handleModal({ enabled: false })}>
            Cancelar
          </Button>
        </Box>
      ),
    })
  }

  useEffect(() => {
    if (disableAll) return
    if (Object.keys(response).length > 0) {
      const buttonArray = []
      if (response.actions.includes('B')) {
        buttonArray.push(
          <>
            <Button
              variant="contained"
              color="error"
              onClick={deleteButtonOnclick}
              key={'B_1'}
              sx={{ display: { xs: 'none', md: 'flex' } }}
              startIcon={<DeleteIcon />}
            >
              Borrar
            </Button>
            <Button
              variant="contained"
              color="error"
              onClick={deleteButtonOnclick}
              sx={{ display: { xs: 'flex', md: 'none' } }}
              key={'B_2'}
            >
              <DeleteIcon />
            </Button>
          </>,
        )
      }
      if (response.actions.includes('CE')) {
        buttonArray.push(
          <>
            <Button
              variant="contained"
              color="error"
              onClick={handleClick}
              key={'CE_1'}
              sx={{ display: { xs: 'none', md: 'flex' } }}
              startIcon={<LockIcon />}
            >
              Cerrar Hoja
            </Button>
            <Button
              variant="contained"
              color="error"
              onClick={handleClick}
              key={'CE_2'}
              sx={{ display: { xs: 'flex', md: 'none' } }}
            >
              <LockIcon />
            </Button>
          </>,
        )
      }
      if (response.actions.includes('A')) {
        buttonArray.push(
          <>
            <Button
              variant="contained"
              color="primary"
              onClick={() => handleOpenClick({ id: response?.id })}
              key={'A_1'}
              startIcon={<LockOpenIcon />}
              sx={{ display: { xs: 'none', md: 'flex' } }}
            >
              Abrir Hoja
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => handleOpenClick({ id: response?.id })}
              key={'A_2'}
              sx={{ display: { xs: 'flex', md: 'none' } }}
            >
              <LockOpenIcon />
            </Button>
          </>,
        )
      }
      if (response.actions.includes('D')) {
        buttonArray.push(
          <>
            <Button
              variant="contained"
              color="primary"
              onClick={() => handleDetalladaClick({ id: response.id })}
              key={'D_1'}
              sx={{ display: { xs: 'none', md: 'flex' } }}
              startIcon={<SearchIcon />}
            >
              Detallada
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => handleDetalladaClick({ id: response.id })}
              key={'D_2'}
              sx={{ display: { xs: 'flex', md: 'none' } }}
            >
              <SearchIcon />
            </Button>
          </>,
        )
      }
      if (response.actions.includes('F')) {
        buttonArray.push(
          <>
            <Button
              variant="contained"
              color="primary"
              onClick={() => handleFirmasClick({ id: response.id })}
              key={'F_1'}
              sx={{ display: { xs: 'none', md: 'flex' } }}
              startIcon={<BorderColorIcon />}
            >
              Firmas
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => handleFirmasClick({ id: response.id })}
              key={'F_2'}
              sx={{ display: { xs: 'flex', md: 'none' } }}
            >
              <BorderColorIcon />
            </Button>
          </>,
        )
      }
      setButtons(buttonArray)
    }
  }, [response])

  const updateTotalAmount = (amount) => {
    setForcedAmount(amount)
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        gap: '10px',
        width: '100%',
        mb: 1,
      }}
    >
      <SnackbarProvider
        maxSnack={1}
        autoHideDuration={2000}
        anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
        variant={'error'}
      />

      <HeaderCard
        data={response}
        clickEnabled={false}
        extended={true}
        amountFocus={true}
        forcedAmount={forcedAmount}
      />

      <Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            flexWrap: 'wrap',
            justifyContent: 'space-between',
            gap: 2,
            width: '100%',
          }}
        >
          <Box sx={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: 2 }}>
            <Button
              sx={{
                display: { xs: 'none', md: 'flex' },
              }}
              startIcon={<ArrowBackIcon />}
              variant="contained"
              color="primary"
              onClick={() => navigate('/hojasgasto/')}
            >
              Volver
            </Button>
            <Button
              sx={{
                display: { xs: 'flex', md: 'none' },
              }}
              variant="contained"
              color="primary"
              onClick={() => navigate('/hojasgasto/')}
            >
              <ArrowBackIcon />
            </Button>
            {!disableAll ? (
              <AddExpenseButton
                id_hoja={id}
                showButton={response?.actions?.includes('C')}
                updateState={handleChangeState}
                fechaInicio={response?.fecha_inicio}
                fechaFin={response?.fecha_fin}
              />
            ) : null}
          </Box>
          <Box
            gap={2}
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: { xs: 'start', sm: 'end' },
              flexWrap: { xs: 'wrap', sm: 'nowrap' },
              gap: 2,
            }}
          >
            {buttons}
          </Box>
        </Box>
      </Box>

      <HojasGastoLin
        disableAll={disableAll}
        id={id}
        fechaInicio={response?.fecha_inicio}
        fechaFin={response?.fecha_fin}
        showButton={response?.actions?.includes('C')}
        handleChangeState={handleChangeState}
        encr={encr}
        updateTotalAmount={(amount) => updateTotalAmount(amount)}
        forceUpdate={iterator}
      />
    </Box>
  )
}
